import { Button, Grid, Typography } from "@mui/material";

import { BankingBreakdownStyles } from "src/components/banking/styles/BankingBreakdown.styles";

interface BankingRowProps {
  placeholder: string;
  content: string | number;
  description?: string;
  isCopy: boolean;
  copyToClipboard: (el: any) => void;
  clientDetails?: {
    name: string;
    customerId: string;
  };
}

function BankingRow(props: BankingRowProps) {
  const classes = BankingBreakdownStyles();
  const { placeholder, content, description, isCopy, copyToClipboard, clientDetails } = props;
  return (
    <Grid container>
      <Grid item xs={8}>
        <Typography className={classes.placeHolder}>{placeholder}</Typography>
        <Typography className={classes.content}>
          {content !== "CustomerId" && content}
          {content === "CustomerId" && `${clientDetails?.customerId} ${clientDetails?.name}`}
        </Typography>
        {description && <Typography className={classes.description}>{description}</Typography>}
      </Grid>
      {/* check if the browser supports copyToClipboard */}
      {window.isSecureContext && isCopy && (
        <Grid item xs={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <div onClick={() => copyToClipboard({ content })}>
            <Button disableRipple variant="outlined" className={classes.icon}>
              Copy
            </Button>
          </div>
        </Grid>
      )}
    </Grid>
  );
}

export default BankingRow;
